import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/system';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const CustomTextField = styled(TextField)(({ theme, customWidth, customMarginTop, customMarginLeft }) => ({
  width: customWidth || '400px',
  marginTop: customMarginTop || '0px',
  marginLeft: customMarginLeft || '0px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    borderColor: '#E7E7FF',
    borderWidth: '1px',
    '&:hover fieldset': {
      borderColor: '#E7E7FF',
    },
    '& fieldset': {
      border: '1px solid #E7E7FF',
      padding: '18px 15px',
      borderRadius: '10px',
    },
    '& input': {
      color: '#B2B4C5 !important',
      marginLeft:'7px',
      fontSize: '13px !important',
      fontFamily: 'Figtree-Regular',
      '&:focus': {
        '& + fieldset': {
          borderColor: '#E7E7FF',
        },
      },
    },
    '& label': {
      color: '#B2B4C5 !important',
      fontWeight: `600 !important`,
      fontSize: '13px !important',
      fontFamily: 'Figtree-Bold !important',
      transform: 'translate(18px, 12px) scale(1) !important',
      '&.Mui-focused': {
        color: '#B2B4C5 !important',
      },
    },
    '& .Mui-focused fieldset': {
      border: '1px solid #E7E7FF !important',
      borderColor: '#E7E7FF',
    },
    '& .Mui-focused label': {
      transform: 'translate(18px, -10px) scale(0.75) !important',
    },
  },
}));

const PasswordFieldForModals = ({ onFocusFn, onBlurFn, value, label, onChangeFn, customWidth, placeholder, customMarginTop, customMarginLeft, isPasswordField }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <CustomTextField
      id="outlined-required"
      label={label}
      value={value}
      onChange={onChangeFn}
      variant="outlined"
      onFocus={onFocusFn}
      onBlur={onBlurFn}
      placeholder={placeholder}
      customWidth={customWidth}
      customMarginTop={customMarginTop}
      InputLabelProps={{
        shrink: true,
        style: {
          color: '#404585',
          fontFamily: 'Figtree-Regular',
          fontWeight:'600',
          transform: 'translate(20px, -9px) scale(0.75)',
        }
      }}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
            >
              {
                showPassword
                  ?
                  <VisibilityOff 
                    fontSize='small' 
                    style={{color:'#B2B4C5'}}
                  />
                  :
                  <Visibility 
                    fontSize='small' 
                    style={{color:'#B2B4C5'}}
                  />
              }
            </IconButton>
          </InputAdornment>
        )
      }}
      customMarginLeft={customMarginLeft}
    />
  );
};

export default PasswordFieldForModals;
